import classNames from "classnames";
import { IconButton } from "@sprout/icon_button";
import CloseIcon from "@sprout/icons/close";

export interface TagProps {
  label: string;
  color?: string;
  size?: string;
  spacing?: boolean;
  className?: string;
  maxWidth?: string;
  truncate?: boolean;
  primary?: boolean;
}

export const Tag = ({
  label,
  color,
  size = "sm",
  spacing,
  className,
  maxWidth,
  truncate = true,
  primary = false,
}: TagProps) => {
  const tagContentClassName = classNames("tag-content", maxWidth || "max-w-[142px]", {
    "tag-truncate": truncate,
  });

  return (
    <span
      className={classNames("tag-container", `tag-container--${size}`, className, {
        "tag-container--primary": primary,
      })}
      style={{ backgroundColor: color, marginLeft: spacing ? 8 : 0 }}
    >
      <span className={tagContentClassName}>
        <span className={classNames("tag-text", `tag-text--${size}`)}>{label}</span>
      </span>
    </span>
  );
};

export interface DestroyableTagProps extends TagProps {
  onClick: () => void;
}

export const DestroyableTag = ({
  label,
  color,
  size = "sm",
  spacing,
  className,
  maxWidth,
  onClick,
  truncate = true,
}: DestroyableTagProps) => {
  const tagContentClassName = classNames("tag-content", maxWidth || "max-w-[142px]", {
    "tag-truncate": truncate,
  });

  return (
    <span
      className={classNames(
        "tag-container",
        "tag-container--destroyable",
        `tag-container--${size}`,
        className,
      )}
      style={{
        backgroundColor: color,
        marginLeft: spacing ? 8 : 0,
      }}
    >
      <span className={tagContentClassName}>
        <span className={classNames("tag-text", `tag-text--${size}`)}>{label}</span>
      </span>
      <span className="tag-icon">
        <IconButton
          label="remove"
          icon={CloseIcon}
          onClick={(e) => {
            e.preventDefault();
            onClick();
          }}
        />
      </span>
    </span>
  );
};

export { default as useTagOverflow } from "./hooks/use_tag_overflow";
